module.exports = __webpack_public_path__ + "static/media/zendesk.443c71f7.svg";